import { render, staticRenderFns } from "./DartsList.vue?vue&type=template&id=99829b7a&scoped=true&"
import script from "./DartsList.vue?vue&type=script&lang=js&"
export * from "./DartsList.vue?vue&type=script&lang=js&"
import style0 from "./DartsList.vue?vue&type=style&index=0&id=99829b7a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99829b7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
